import React, { Component } from 'react'
import { Link, navigate } from 'gatsby'
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardTitle,
  CardText,
  Row,
  Col,
} from 'reactstrap'

import classnames from 'classnames'
import BrandLogo from './../../assets/images/brand_logo_1.png'
import BrandLogo2 from './../../assets/images/brand_logo_2.png'
import BrandLogo3 from './../../assets/images/brand_logo_3.png'
import BrandLogo4 from './../../assets/images/brand_logo_4.png'
import Heart from './../../assets/images/noun_Heart.png'
import ListBlack from './../../assets/images/list_gray.png'
import ListWhite from './../../assets/images/list_white.png'
import GridBlack from './../../assets/images/grid_black.png'
import GridWhite from './../../assets/images/grid_white.png'
import HeartActive from './../../assets/images/heart_active.png'
import HeartListView from './../../assets/images/noun_Heart_favret.png'
import axios from 'axios'
import _ from 'lodash'
import Cookies from 'universal-cookie'
import { HOSTNAME, IMG_HOSTNAME } from '../config'

const cookies = new Cookies()

let initialState = {
  brandsList: [],
  activeTab: '1',
  displayType: 'grid_view',
  favorites: [],
  category: '',
  user: {},
  isLoading: false,
}
class Home extends Component {
  constructor(props) {
    super(props)
    this.state = initialState
    this.selectCategory = this.selectCategory.bind(this)
  }

  selectCategory(tab) {
    if (this.state.category !== tab) {
      let labelkey = tab === '' ? 'All brands' : tab
      window &&
        window.ga &&
        window.ga('send', 'event', {
          eventCategory: `Brand Category - ${labelkey} Clicked`,
          eventAction: 'Clicked',
          eventLabel: labelkey + ' Category Clicked',
          transport: '1',
        })
      this.setState({ category: tab })
    }
  }

  componentWillMount() {
    this.setState({ isLoading: true })
  }

  componentDidMount() {
    const user = cookies.get('user')
    const userToken = this.getParameterByName('userverify')
    if (!user || user === 'undefined') {
      if (userToken && userToken != '') {
        this.getUser(userToken)
        this.getBrands()
      } else {
        navigate('/signup')
      }
    } else {
      this.getUser(user._id, true)
      this.getBrands()
      setTimeout(function() {
        document.title = 'Home | American Field'
        let meta = document.getElementsByTagName('meta')
        for (var i = 0; i < meta.length; i++) {
          if (meta[i].name.toLowerCase() === 'description') {
            meta[i].content =
              'The American Field is a unique platform to provide you all the best brands at one place.'
          }
          if (meta[i].name.toLowerCase() === 'url') {
            meta[i].content = 'https://app.shopaf.co'
          }
        }
      }, 300)
    }
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  getBrands() {
    let self = this
    axios
      .get(HOSTNAME + 'getBrands')
      .then(function(response) {
        let res = response.data
        if (res.success) {
          self.setState({ brandsList: res.data, isLoading: false })
          self.props.brands(res.data)
        }
      })
      .catch(function(error) {
        self.setState({ brandsList: [], isLoading: false })
      })
  }

  getUser(id, isInner) {
    let self = this
    let obj = { id }
    axios
      .post(HOSTNAME + 'getUser', obj)
      .then(function(response) {
        let res = response.data
        if (res.success) {
          let expires = new Date()
          expires.setHours(expires.getHours() + 24)
          expires = new Date(expires)
          let data = res.data
          let favorites = data.favorites
          delete data.favorites
          cookies.set('user', data, { path: '/', expires })
          // cookies.set('favorites', JSON.stringify(favorites), { path: '/', expires });
          self.setState({ user: res.data, favorites })
          if (!isInner) {
            let navigatePath = '/'
            const brandDetail = cookies.get('branddetail')
            if (brandDetail) {
              navigatePath = brandDetail.url
            }
            setTimeout(function() {
              navigate(navigatePath)
              cookies.remove('branddetail')
              document.cookie = 'branddetail =; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
            }, 100)
          }
        }
      })
      .catch(function(error) {
        self.setState({ user: {} })
      })
  }

  selectFavorites(val) {
    window &&
      window.ga &&
      window.ga('send', 'event', {
        eventCategory: 'Favorite | Unfavorite brand',
        eventAction: 'Favorite | Unfavorite brand clicked',
        eventLabel: 'Favorite | Unfavorite brand clicked',
        transport: '1',
      })
    let self = this
    const user = this.state.user
    let obj = {}
    obj.userId = user._id
    obj.brandId = val._id
    axios
      .post(HOSTNAME + 'selectFavorite', obj)
      .then(function(response) {
        let res = response.data
        if (res.success) {
          self.getUser(user._id, true)
        } else {
        }
      })
      .catch(function(error) {
        self.setState({ resMessage: error, resType: 'alert alert-danger' })
      })
  }

  selectBrand(val) {
    window &&
      window.ga &&
      window.ga('send', 'event', {
        eventCategory: `Brand details - ${val.title}`,
        eventAction: 'Brand details navigate',
        eventLabel: `Brand details - ${val.title}`,
        transport: '1',
      })
    const { user } = this.state
    let page_url = String(val.title).toLowerCase()
    if (val.title !== 'Krammer + Stoudt') {
      page_url = page_url.replace(/ /g, '-')
    } else {
      page_url = 'krammer-stoudt'
    }
    navigate(page_url, { state: { brand: val, fav: this.state.favorites } }) //_.get(user, 'favorites', [])
  }

  selectViewType(key) {
    this.setState({ displayType: key })
    let labelkey = key === 'list_view' ? 'List view' : 'Grid view'
    window &&
      window.ga &&
      window.ga('send', 'event', {
        eventCategory: 'Brand view',
        eventAction: labelkey + ' clicked',
        eventLabel: labelkey + ' clicked',
        transport: '1',
      })
  }

  render() {
    let { brandsList, displayType, user, category, isLoading } = this.state
    const { searchTerm } = this.props
    let fav = this.state.favorites //_.get(user, 'favorites', []);
    brandsList = brandsList.filter(function(u) {
      return u.title && u.title.toLowerCase().match(searchTerm.toLowerCase())
    })
    if (category !== '') {
      brandsList = _.filter(brandsList, function(o) {
        return o.category === category
      })
    }
    return (
      <div>
        {isLoading ? (
          <div className="loader__section">
            <div className="loading" />
          </div>
        ) : (
          <div id="wrappper" className="home__page page">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="custome__tabs">
                    <div className="row d-flex align-items-center">
                      <div className="col-lg-7 col-md-12 text-left">
                        <div className="nav-tabs--scroll">
                          <Nav tabs>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: category === '',
                                })}
                                onClick={() => {
                                  this.selectCategory('')
                                }}
                              >
                                All Brands
                              </NavLink>
                            </NavItem>
                            {/* <NavItem>
                              <NavLink
                                className={classnames({
                                  active: category === 'Mens',
                                })}
                                onClick={() => {
                                  this.selectCategory('Mens')
                                }}
                              >
                                Mens
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: category === 'Womens',
                                })}
                                onClick={() => {
                                  this.selectCategory('Womens')
                                }}
                              >
                                Womens
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: category === 'Home Goods',
                                })}
                                onClick={() => {
                                  this.selectCategory('Home Goods')
                                }}
                              >
                                Homegoods
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: category === 'Gear',
                                })}
                                onClick={() => {
                                  this.selectCategory('Gear')
                                }}
                              >
                                Gear
                              </NavLink>
                            </NavItem> */}
                          </Nav>
                        </div>
                      </div>
                      <div className="col-lg-5 text-right d-none d-lg-block">
                        <div className="chamge__view--btn">
                          <div
                            className="btn-group btn-group-toggle"
                            data-toggle="buttons"
                          >
                            <label
                              onClick={this.selectViewType.bind(
                                this,
                                'list_view'
                              )}
                              className={
                                displayType === 'list_view'
                                  ? 'btn active'
                                  : 'btn'
                              }
                            >
                              <img
                                src={
                                  displayType === 'list_view'
                                    ? ListWhite
                                    : ListBlack
                                }
                              />
                            </label>
                            <label
                              onClick={this.selectViewType.bind(
                                this,
                                'grid_view'
                              )}
                              className={
                                displayType === 'grid_view'
                                  ? 'btn active'
                                  : 'btn'
                              }
                            >
                              <img
                                src={
                                  displayType === 'grid_view'
                                    ? GridWhite
                                    : GridBlack
                                }
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <TabContent activeTab={category}>
                      <TabPane tabId={category}>
                        <Row>
                          <Col lg="12" md="12" sm="12" xs="12">
                            <div
                              className={
                                displayType === 'list_view'
                                  ? 'list_view brands__section'
                                  : 'grid_view brands__section'
                              }
                            >
                              <ul className="brands__list">
                                {brandsList && brandsList.length > 0
                                  ? brandsList.map((val, index) => {
                                      let favImg = Heart
                                      if (displayType === 'list_view') {
                                        favImg = HeartListView
                                      }
                                      _.forEach(fav, function(data, index) {
                                        if (val._id === data._id) {
                                          favImg = HeartActive
                                        }
                                      })
                                      return (
                                        <li
                                          key={index}
                                          className="brands__list--item"
                                        >
                                          <div
                                            onClick={this.selectFavorites.bind(
                                              this,
                                              val
                                            )}
                                            className="hart__icon"
                                          >
                                            <img src={favImg} />
                                          </div>
                                          <div
                                            onClick={this.selectBrand.bind(
                                              this,
                                              val
                                            )}
                                          >
                                            <div
                                              className="brands_description"
                                              style={{
                                                backgroundImage:
                                                  'url(' +
                                                  IMG_HOSTNAME +
                                                  _.get(val, 'image', '') +
                                                  ')',
                                              }}
                                            >
                                              <div className="brands_logo">
                                                <img
                                                  src={
                                                    IMG_HOSTNAME +
                                                    _.get(val, 'logo', '')
                                                  }
                                                />
                                              </div>
                                              <div className="description_text">
                                                <h2>{val.title}</h2>
                                                <p>
                                                  {val.description.substring(
                                                    0,
                                                    100
                                                  )}
                                                  ...<strong>Read More</strong>
                                                </p>
                                              </div>
                                              <div className="overlay" />
                                            </div>
                                          </div>
                                        </li>
                                      )
                                    })
                                  : ''}
                              </ul>
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default Home
